import * as React from 'react';

import HatWand140 from './HatWand140';

export const hatWand140 = () => <HatWand140 />;

export default {
    title: 'Illustration/HatWand140',
    component: HatWand140,
    parameters: {
        notes: "`import HatWand140 from 'box-ui-elements/es/illustration/HatWand140';`",
    },
};
